import { IconPersons } from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from 'components/common/Menu';

const menuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'Accounts',
		link: '/accounts/users',
		icon: <IconPersons />,
	},
	{
		type: 'Clickable',
		text: 'Admin accounts',
		link: '/accounts/admin-users',
		icon: <IconPersons />,
	},
];

export default menuConfig;
